<template>
  <div class="settings-backup">
    <h2>{{ $t('settings.backup.title') }}</h2>
    <div class="buttons-container">
      <edit-button :editOptions="['save']" @click="save">
        <template>
          <span class="text">{{ $t('button.backup') }}</span>
        </template>
      </edit-button>
      <b-upload @input="upload($event, 'backup')">
        <a class="button">{{ $t('button.restore') }}</a>
      </b-upload>
    </div>
  </div>
</template>

<script>
import uploadZip from '@/api/uploadZip'
import EditButton from '@/components/EditButton'
export default {
  components: {
    EditButton
  },
  methods: {
    save() {
      if (!this.loadingLicense) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/backup`
        this.loadingLicense = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.downloadObjectAsJson(data, 'backup')
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.loadingLicense = false
          })
      }
    },
    downloadObjectAsJson(exportObj, exportName) {
      const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportObj))
      const downloadAnchorNode = document.createElement('a')
      downloadAnchorNode.setAttribute('href', dataStr)
      downloadAnchorNode.setAttribute('download', exportName + '.json')
      document.body.appendChild(downloadAnchorNode) // required for firefox
      downloadAnchorNode.click()
      downloadAnchorNode.remove()
    },
    upload(...arg) {
      uploadZip.apply(this, arg)
    }
  }
}
</script>
<style lang="scss">
.settings-backup {
  margin-bottom: 3rem;
  .buttons-container {
    display: flex;
    .edit-button {
      width: max-content;
      display: block;
      float: left;
    }
    .upload.control {
      display: block;
      float: left;
      height: 1.35rem;
      font-size: 0.9em;
      margin-left: 1rem;
      .button {
        padding: 0;
        height: 100%;
        padding-right: 1.25rem;
        padding-left: 1.25rem;
        border-color: #d02129;
        color: #d02129;
      }
    }
  }
}
</style>
